// extracted by mini-css-extract-plugin
module.exports = {"product-card":"centeredtext_product-card__9nCHP","centered__text":"centeredtext_centered__text__iwoXF","container":"centeredtext_container__ypjDk"};